export function PrivacyContent() {
  return (
    <div className="space-y-6 text-sm">
      <section>
        <h2 className="text-lg font-semibold mb-3">Präambel</h2>
        <p className="mb-4">
          Mit der folgenden Datenschutzerklärung möchten wir Sie darüber aufklären, welche Arten
          Ihrer personenbezogenen Daten (nachfolgend auch kurz als "Daten" bezeichnet) wir zu
          welchen Zwecken und in welchem Umfang im Rahmen der Bereitstellung unserer Applikation
          verarbeiten.
        </p>
        <p className="mb-4">Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</p>
        <p className="mb-4">Stand: 24. August 2026</p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Inhaltsübersicht</h2>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>Präambel</li>
          <li>Verantwortlicher</li>
          <li>Kontakt Datenschutzbeauftragter</li>
          <li>Übersicht der Verarbeitungen</li>
          <li>Maßgebliche Rechtsgrundlagen</li>
          <li>Sicherheitsmaßnahmen</li>
          <li>Übermittlung von personenbezogenen Daten</li>
          <li>Internationale Datentransfers</li>
          <li>Allgemeine Informationen zur Datenspeicherung und Löschung</li>
          <li>Rechte der betroffenen Personen</li>
          <li>Geschäftsprozesse und -verfahren</li>
          <li>Bereitstellung des Onlineangebots und Webhosting</li>
          <li>Einsatz von Cookies</li>
          <li>Verarbeitung von Daten im Rahmen von Applikationen (Apps)</li>
          <li>Registrierung, Anmeldung und Nutzerkonto</li>
          <li>Kontakt- und Anfrageverwaltung</li>
          <li>Künstliche Intelligenz (KI)</li>
          <li>Newsletter und elektronische Benachrichtigungen</li>
          <li>Webanalyse, Monitoring und Optimierung</li>
          <li>Plug-ins und eingebettete Funktionen sowie Inhalte</li>
          <li>Änderung und Aktualisierung</li>
          <li>Begriffsdefinitionen</li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Verantwortlicher</h2>
        <p className="mb-4">
          BLIKS IO GmbH
          <br />
          Johannstr. 37
          <br />
          40476 Düsseldorf
        </p>
        <p className="mb-4">Vertretungsberechtigte Personen: Prof. Dr. Nicolas Burkhardt</p>
        <p className="mb-4">
          E-Mail-Adresse:{' '}
          <a
            href="mailto:hello@bliks.io"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            hello@bliks.io
          </a>
        </p>
        <p className="mb-4">
          Impressum:{' '}
          <a
            href="https://bliks.io/impressum"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            https://bliks.io/impressum
          </a>
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Kontakt Datenschutzbeauftragter</h2>
        <p className="mb-4">
          LCube - Datenschutz & IT-Sicherheit e.K.
          <br />
          Hardenbergstr. 15
          <br />
          31275 Lehrte
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Übersicht der Verarbeitungen</h2>
        <p className="mb-4">
          Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer
          Verarbeitung zusammen und verweist auf die betroffenen Personen.
        </p>
        <h3 className="font-semibold mb-2">Arten der verarbeiteten Daten</h3>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>Bestandsdaten.</li>
          <li>Zahlungsdaten.</li>
          <li>Standortdaten.</li>
          <li>Kontaktdaten.</li>
          <li>Inhaltsdaten.</li>
          <li>Vertragsdaten.</li>
          <li>Nutzungsdaten.</li>
          <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
          <li>Protokolldaten.</li>
        </ul>
        <h3 className="font-semibold mb-2">Kategorien betroffener Personen</h3>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>Leistungsempfänger und Auftraggeber.</li>
          <li>Interessenten.</li>
          <li>Kommunikationspartner.</li>
          <li>Nutzer.</li>
          <li>Geschäfts- und Vertragspartner.</li>
          <li>Mandanten.</li>
          <li>Dritte Personen.</li>
        </ul>
        <h3 className="font-semibold mb-2">Zwecke der Verarbeitung</h3>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>Erbringung vertraglicher Leistungen und Erfüllung vertraglicher Pflichten.</li>
          <li>Kommunikation.</li>
          <li>Sicherheitsmaßnahmen.</li>
          <li>Direktmarketing.</li>
          <li>Reichweitenmessung.</li>
          <li>Tracking.</li>
          <li>Büro- und Organisationsverfahren.</li>
          <li>Zielgruppenbildung.</li>
          <li>Organisations- und Verwaltungsverfahren.</li>
          <li>Feedback.</li>
          <li>Marketing.</li>
          <li>Profile mit nutzerbezogenen Informationen.</li>
          <li>Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.</li>
          <li>Informationstechnische Infrastruktur.</li>
          <li>Geschäftsprozesse und betriebswirtschaftliche Verfahren.</li>
          <li>Künstliche Intelligenz (KI).</li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Maßgebliche Rechtsgrundlagen</h2>
        <p className="mb-4">
          Maßgebliche Rechtsgrundlagen nach der DSGVO: Im Folgenden erhalten Sie eine Übersicht der
          Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten. Bitte
          nehmen Sie zur Kenntnis, dass neben den Regelungen der DSGVO nationale Datenschutzvorgaben
          in Ihrem bzw. unserem Wohn- oder Sitzland gelten können. Sollten ferner im Einzelfall
          speziellere Rechtsgrundlagen maßgeblich sein, teilen wir Ihnen diese in der
          Datenschutzerklärung mit.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO) - Die betroffene Person hat ihre
            Einwilligung in die Verarbeitung der sie betreffenden personenbezogenen Daten für einen
            spezifischen Zweck oder mehrere bestimmte Zwecke gegeben.
          </li>
          <li>
            Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO) - Die
            Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene
            Person ist, oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, die auf
            Anfrage der betroffenen Person erfolgen.
          </li>
          <li>
            Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO) - Die Verarbeitung ist zur
            Erfüllung einer rechtlichen Verpflichtung erforderlich, der der Verantwortliche
            unterliegt.
          </li>
          <li>
            Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO) - die Verarbeitung ist zur
            Wahrung der berechtigten Interessen des Verantwortlichen oder eines Dritten notwendig,
            vorausgesetzt, dass die Interessen, Grundrechte und Grundfreiheiten der betroffenen
            Person, die den Schutz personenbezogener Daten verlangen, nicht überwiegen.
          </li>
        </ul>
        <p className="mb-4">
          Nationale Datenschutzregelungen in Deutschland: Zusätzlich zu den Datenschutzregelungen
          der DSGVO gelten nationale Regelungen zum Datenschutz in Deutschland. Hierzu gehört
          insbesondere das Bundesdatenschutzgesetz (BDSG). Das BDSG enthält insbesondere
          Spezialregelungen zum Recht auf Auskunft, zum Recht auf Löschung, zum Widerspruchsrecht,
          zur Verarbeitung besonderer Kategorien personenbezogener Daten, zur Verarbeitung für
          andere Zwecke und zur Übermittlung sowie automatisierten Entscheidungsfindung im
          Einzelfall einschließlich Profiling. Ferner können Landesdatenschutzgesetze der einzelnen
          Bundesländer zur Anwendung gelangen.
        </p>
        <p className="mb-4">
          Hinweis auf Geltung DSGVO und Schweizer DSG: Diese Datenschutzhinweise dienen sowohl der
          Informationserteilung nach dem Schweizer DSG als auch nach der Datenschutzgrundverordnung
          (DSGVO). Aus diesem Grund bitten wir Sie zu beachten, dass aufgrund der breiteren
          räumlichen Anwendung und Verständlichkeit die Begriffe der DSGVO verwendet werden.
          Insbesondere statt der im Schweizer DSG verwendeten Begriffe „Bearbeitung" von
          „Personendaten", "überwiegendes Interesse" und "besonders schützenswerte Personendaten"
          werden die in der DSGVO verwendeten Begriffe „Verarbeitung" von „personenbezogenen Daten"
          sowie "berechtigtes Interesse" und "besondere Kategorien von Daten" verwendet. Die
          gesetzliche Bedeutung der Begriffe wird jedoch im Rahmen der Geltung des Schweizer DSG
          weiterhin nach dem Schweizer DSG bestimmt.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Sicherheitsmaßnahmen</h2>
        <p className="mb-4">
          Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter Berücksichtigung des Stands der
          Technik, der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke
          der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeiten und des
          Ausmaßes der Bedrohung der Rechte und Freiheiten natürlicher Personen geeignete technische
          und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu
          gewährleisten.
        </p>
        <p className="mb-4">
          Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und
          Verfügbarkeit von Daten durch Kontrolle des physischen und elektronischen Zugangs zu den
          Daten als auch des sie betreffenden Zugriffs, der Eingabe, der Weitergabe, der Sicherung
          der Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die
          eine Wahrnehmung von Betroffenenrechten, die Löschung von Daten und Reaktionen auf die
          Gefährdung der Daten gewährleisten. Ferner berücksichtigen wir den Schutz
          personenbezogener Daten bereits bei der Entwicklung bzw. Auswahl von Hardware, Software
          sowie Verfahren entsprechend dem Prinzip des Datenschutzes, durch Technikgestaltung und
          durch datenschutzfreundliche Voreinstellungen.
        </p>
        <p className="mb-4">
          Sicherung von Online-Verbindungen durch TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um
          die Daten der Nutzer, die über unsere Online-Dienste übertragen werden, vor unerlaubten
          Zugriffen zu schützen, setzen wir auf die TLS-/SSL-Verschlüsselungstechnologie. Secure
          Sockets Layer (SSL) und Transport Layer Security (TLS) sind die Eckpfeiler der sicheren
          Datenübertragung im Internet. Diese Technologien verschlüsseln die Informationen, die
          zwischen der Website oder App und dem Browser des Nutzers (oder zwischen zwei Servern)
          übertragen werden, wodurch die Daten vor unbefugtem Zugriff geschützt sind. TLS, als die
          weiterentwickelte und sicherere Version von SSL, gewährleistet, dass alle
          Datenübertragungen den höchsten Sicherheitsstandards entsprechen. Wenn eine Website durch
          ein SSL-/TLS-Zertifikat gesichert ist, wird dies durch die Anzeige von HTTPS in der URL
          signalisiert. Dies dient als ein Indikator für die Nutzer, dass ihre Daten sicher und
          verschlüsselt übertragen werden.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Übermittlung von personenbezogenen Daten</h2>
        <p className="mb-4">
          Im Rahmen unserer Verarbeitung von personenbezogenen Daten kommt es vor, dass diese an
          andere Stellen, Unternehmen, rechtlich selbstständige Organisationseinheiten oder Personen
          übermittelt beziehungsweise ihnen gegenüber offengelegt werden. Zu den Empfängern dieser
          Daten können z. B. mit IT-Aufgaben beauftragte Dienstleister gehören oder Anbieter von
          Diensten und Inhalten, die in eine Website eingebunden sind. In solchen Fällen beachten
          wir die gesetzlichen Vorgaben und schließen insbesondere entsprechende Verträge bzw.
          Vereinbarungen, die dem Schutz Ihrer Daten dienen, mit den Empfängern Ihrer Daten ab.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Internationale Datentransfers</h2>
        <p className="mb-4">
          Datenverarbeitung in Drittländern: Sofern wir Daten in ein Drittland (d. h. außerhalb der
          Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) übermitteln oder
          dies im Rahmen der Nutzung von Diensten Dritter oder der Offenlegung bzw. Übermittlung von
          Daten an andere Personen, Stellen oder Unternehmen geschieht (was erkennbar wird anhand
          der Postadresse des jeweiligen Anbieters oder wenn in der Datenschutzerklärung
          ausdrücklich auf den Datentransfer in Drittländer hingewiesen wird), erfolgt dies stets im
          Einklang mit den gesetzlichen Vorgaben.
        </p>
        <p className="mb-4">
          Für Datenübermittlungen in die USA stützen wir uns vorrangig auf das Data Privacy
          Framework (DPF), welches durch einen Angemessenheitsbeschluss der EU-Kommission vom
          10.07.2023 als sicherer Rechtsrahmen anerkannt wurde. Zusätzlich haben wir mit den
          jeweiligen Anbietern Standardvertragsklauseln abgeschlossen, die den Vorgaben der
          EU-Kommission entsprechen und vertragliche Verpflichtungen zum Schutz Ihrer Daten
          festlegen.
        </p>
        <p className="mb-4">
          Diese zweifache Absicherung gewährleistet einen umfassenden Schutz Ihrer Daten: Das DPF
          bildet die primäre Schutzebene, während die Standardvertragsklauseln als zusätzliche
          Sicherheit dienen. Sollten sich Änderungen im Rahmen des DPF ergeben, greifen die
          Standardvertragsklauseln als zuverlässige Rückfalloption ein. So stellen wir sicher, dass
          Ihre Daten auch bei etwaigen politischen oder rechtlichen Veränderungen stets angemessen
          geschützt bleiben.
        </p>
        <p className="mb-4">
          Bei den einzelnen Diensteanbietern informieren wir Sie darüber, ob sie nach dem DPF
          zertifiziert sind und ob Standardvertragsklauseln vorliegen. Weitere Informationen zum DPF
          und eine Liste der zertifizierten Unternehmen finden Sie auf der Website des
          US-Handelsministeriums unter{' '}
          <a
            href="https://www.dataprivacyframework.gov/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            https://www.dataprivacyframework.gov/
          </a>{' '}
          (in englischer Sprache).
        </p>
        <p className="mb-4">
          Für Datenübermittlungen in andere Drittländer gelten entsprechende Sicherheitsmaßnahmen,
          insbesondere Standardvertragsklauseln, ausdrückliche Einwilligungen oder gesetzlich
          erforderliche Übermittlungen. Informationen zu Drittlandtransfers und geltenden
          Angemessenheitsbeschlüssen können Sie dem Informationsangebot der EU-Kommission entnehmen:{' '}
          <a
            href="https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en?prefLang=de"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en?prefLang=de.
          </a>
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">
          Allgemeine Informationen zur Datenspeicherung und Löschung
        </h2>
        <p className="mb-4">
          Wir löschen personenbezogene Daten, die wir verarbeiten, gemäß den gesetzlichen
          Bestimmungen, sobald die zugrundeliegenden Einwilligungen widerrufen werden oder keine
          weiteren rechtlichen Grundlagen für die Verarbeitung bestehen. Dies betrifft Fälle, in
          denen der ursprüngliche Verarbeitungszweck entfällt oder die Daten nicht mehr benötigt
          werden. Ausnahmen von dieser Regelung bestehen, wenn gesetzliche Pflichten oder besondere
          Interessen eine längere Aufbewahrung oder Archivierung der Daten erfordern.
        </p>
        <p className="mb-4">
          Insbesondere müssen Daten, die aus handels- oder steuerrechtlichen Gründen aufbewahrt
          werden müssen oder deren Speicherung notwendig ist zur Rechtsverfolgung oder zum Schutz
          der Rechte anderer natürlicher oder juristischer Personen, entsprechend archiviert werden.
        </p>
        <p className="mb-4">
          Unsere Datenschutzhinweise enthalten zusätzliche Informationen zur Aufbewahrung und
          Löschung von Daten, die speziell für bestimmte Verarbeitungsprozesse gelten.
        </p>
        <p className="mb-4">
          Bei mehreren Angaben zur Aufbewahrungsdauer oder Löschungsfristen eines Datums, ist stets
          die längste Frist maßgeblich. Daten, die nicht mehr für den ursprünglich vorgesehenen
          Zweck, sondern aufgrund gesetzlicher Vorgaben oder anderer Gründe aufbewahrt werden,
          verarbeiten wir ausschließlich zu den Gründen, die ihre Aufbewahrung rechtfertigen.
        </p>
        <p className="mb-4">
          Aufbewahrung und Löschung von Daten: Die folgenden allgemeinen Fristen gelten für die
          Aufbewahrung und Archivierung nach deutschem Recht:
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            10 Jahre - Aufbewahrungsfrist für Bücher und Aufzeichnungen, Jahresabschlüsse,
            Inventare, Lageberichte, Eröffnungsbilanz sowie die zu ihrem Verständnis erforderlichen
            Arbeitsanweisungen und sonstigen Organisationsunterlagen (§ 147 Abs. 1 Nr. 1 i.V.m. Abs.
            3 AO, § 257 Abs. 1 Nr. 1 i.V.m. Abs. 4 HGB).
          </li>
          <li>
            8 Jahre - Buchungsbelege, wie z. B. Rechnungen und Kostenbelege (§ 147 Abs. 1 Nr. 4 und
            4a i.V.m. Abs. 3 Satz 1 AO, § 14b Abs. 1 UStG sowie § 257 Abs. 1 Nr. 4 i.V.m. Abs. 4
            HGB).
          </li>
          <li>
            6 Jahre - Übrige Geschäftsunterlagen: empfangene Handels- oder Geschäftsbriefe,
            Wiedergaben der abgesandten Handels- oder Geschäftsbriefe, sonstige Unterlagen, soweit
            sie für die Besteuerung von Bedeutung sind, z. B. Stundenlohnzettel,
            Betriebsabrechnungsbögen, Kalkulationsunterlagen, Preisauszeichnungen, aber auch
            Lohnabrechnungsunterlagen, soweit sie nicht bereits Buchungsbelege sind und
            Kassenstreifen (§ 147 Abs. 1 Nr. 2, 3, 5 i.V.m. Abs. 3 AO, § 257 Abs. 1 Nr. 2 u. 3
            i.V.m. Abs. 4 HGB).
          </li>
          <li>
            3 Jahre - Daten, die erforderlich sind, um potenzielle Gewährleistungs- und
            Schadensersatzansprüche oder ähnliche vertragliche Ansprüche und Rechte zu
            berücksichtigen sowie damit verbundene Anfragen zu bearbeiten, basierend auf früheren
            Geschäftserfahrungen und üblichen Branchenpraktiken, werden für die Dauer der regulären
            gesetzlichen Verjährungsfrist von drei Jahren gespeichert (§§ 195, 199 BGB).
          </li>
        </ul>
        <p className="mb-4">
          Fristbeginn mit Ablauf des Jahres: Beginnt eine Frist nicht ausdrücklich zu einem
          bestimmten Datum und beträgt sie mindestens ein Jahr, so startet sie automatisch am Ende
          des Kalenderjahres, in dem das fristauslösende Ereignis eingetreten ist. Im Fall laufender
          Vertragsverhältnisse, in deren Rahmen Daten gespeichert werden, ist das fristauslösende
          Ereignis der Zeitpunkt des Wirksamwerdens der Kündigung oder sonstige Beendigung des
          Rechtsverhältnisses.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Rechte der betroffenen Personen</h2>
        <p className="mb-4">
          Rechte der betroffenen Personen aus der DSGVO: Ihnen stehen als Betroffene nach der DSGVO
          verschiedene Rechte zu, die sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Widerspruchsrecht: Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
            Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden
            personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt,
            Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes
            Profiling. Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um
            Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die
            Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung
            einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in
            Verbindung steht.
          </li>
          <li>
            Widerrufsrecht bei Einwilligungen: Sie haben das Recht, erteilte Einwilligungen
            jederzeit zu widerrufen.
          </li>
          <li>
            Auskunftsrecht: Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob
            betreffende Daten verarbeitet werden und auf Auskunft über diese Daten sowie auf weitere
            Informationen und Kopie der Daten entsprechend den gesetzlichen Vorgaben.
          </li>
          <li>
            Recht auf Berichtigung: Sie haben entsprechend den gesetzlichen Vorgaben das Recht, die
            Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden
            unrichtigen Daten zu verlangen.
          </li>
          <li>
            Recht auf Löschung und Einschränkung der Verarbeitung: Sie haben nach Maßgabe der
            gesetzlichen Vorgaben das Recht, zu verlangen, dass Sie betreffende Daten unverzüglich
            gelöscht werden, bzw. alternativ nach Maßgabe der gesetzlichen Vorgaben eine
            Einschränkung der Verarbeitung der Daten zu verlangen.
          </li>
          <li>
            Recht auf Datenübertragbarkeit: Sie haben das Recht, Sie betreffende Daten, die Sie uns
            bereitgestellt haben, nach Maßgabe der gesetzlichen Vorgaben in einem strukturierten,
            gängigen und maschinenlesbaren Format zu erhalten oder deren Übermittlung an einen
            anderen Verantwortlichen zu fordern.
          </li>
          <li>
            Beschwerde bei Aufsichtsbehörde: Entsprechend den gesetzlichen Vorgaben und unbeschadet
            eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs, haben Sie
            ferner das Recht, bei einer Datenschutzaufsichtsbehörde, insbesondere einer
            Aufsichtsbehörde im Mitgliedstaat, in dem Sie sich gewöhnlich aufhalten, der
            Aufsichtsbehörde Ihres Arbeitsplatzes oder des Ortes des mutmaßlichen Verstoßes, eine
            Beschwerde einzulegen, wenn Sie der Ansicht sei sollten, dass die Verarbeitung der Ihre
            Person betreffenden personenbezogenen Daten gegen die DSGVO verstößt.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Geschäftsprozesse und -verfahren</h2>
        <p className="mb-4">
          Personenbezogene Daten von Leistungsempfängern und Auftraggebern – darunter Kunden,
          Klienten oder in speziellen Fällen Mandanten, Patienten oder Geschäftspartner sowie
          weitere Dritte – werden im Rahmen vertraglicher sowie vergleichbarer Rechtsverhältnisse
          und vorvertraglicher Maßnahmen wie der Anbahnung von Geschäftsbeziehungen verarbeitet.
          Diese Datenverarbeitung unterstützt und erleichtert betriebswirtschaftliche Abläufe in
          Bereichen wie Kundenmanagement, Vertrieb, Zahlungsverkehr, Buchhaltung und
          Projektmanagement.
        </p>
        <p className="mb-4">
          Die erfassten Daten dienen dazu, vertragliche Verpflichtungen zu erfüllen und betriebliche
          Prozesse effizient zu gestalten. Hierzu gehört die Abwicklung von Geschäftstransaktionen,
          das Management von Kundenbeziehungen, die Optimierung von Vertriebsstrategien sowie die
          Gewährleistung interner Rechnungs- und Finanzprozesse. Zusätzlich unterstützen die Daten
          die Wahrung der Rechte des Verantwortlichen und fördern Verwaltungsaufgaben sowie die
          Organisation des Unternehmens.
        </p>
        <p className="mb-4">
          Personenbezogene Daten können an Dritte weitergegeben werden, sofern dies zur Erfüllung
          der genannten Zwecke oder gesetzlicher Verpflichtungen notwendig ist. Nach Ablauf
          gesetzlicher Aufbewahrungsfristen oder wenn der Zweck der Verarbeitung entfällt, werden
          die Daten gelöscht. Dies umfasst auch Daten, die aufgrund von steuerrechtlichen und
          gesetzlichen Nachweispflichten länger gespeichert werden müssen.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
            Kontaktinformationen, Kundennummer, etc.); Zahlungsdaten (z. B. Bankverbindungen,
            Rechnungen, Zahlungshistorie); Kontaktdaten (z. B. Post- und E-Mail-Adressen oder
            Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und Beiträge
            sowie die sie betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder
            Zeitpunkt der Erstellung); Vertragsdaten (z. B. Vertragsgegenstand, Laufzeit,
            Kundenkategorie); Protokolldaten (z. B. Logfiles betreffend Logins oder den Abruf von
            Daten oder Zugriffszeiten.); Meta-, Kommunikations- und Verfahrensdaten (z. B.
            IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte Personen). Nutzungsdaten
            (z. B. Seitenaufrufe und Verweildauer, Klickpfade, Nutzungsintensität und -frequenz,
            verwendete Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und Funktionen).
          </li>
          <li>
            Betroffene Personen: Leistungsempfänger und Auftraggeber; Interessenten;
            Kommunikationspartner; Geschäfts- und Vertragspartner; Dritte Personen. Mandanten.
          </li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Erbringung vertraglicher Leistungen
            und Erfüllung vertraglicher Pflichten; Büro- und Organisationsverfahren;
            Geschäftsprozesse und betriebswirtschaftliche Verfahren; Kommunikation.
            Informationstechnische Infrastruktur (Betrieb und Bereitstellung von
            Informationssystemen und technischen Geräten (Computer, Server etc.)).
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung".
          </li>
          <li>
            Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO); Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO). Rechtliche
            Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Mandantenverwaltung: Verfahren, die im Rahmen der Mandantenverwaltung erforderlich sind,
            umfassen z. B. die Akquise und Aufnahme neuer Mandanten, die Entwicklung von Strategien
            zur Förderung der Mandantenbindung sowie die Sicherstellung effektiver
            Mandantenkommunikation und Terminvereinbarung. Es wird ein umfassender Mandantenservice
            bereitgestellt. Diese Verfahren beinhalten auch die Führung und Verwaltung von
            Mandantenakten, die sichere Dokumentation rechtlicher Vorgänge und die Gewährleistung
            der Vertraulichkeit und Integrität von Mandantendaten. Zudem werden Prozesse definiert
            für die Weitergabe von Mandanteninformationen an Dritte, wie beispielsweise Gerichte
            oder andere Rechtsdienstleister. Es sind Verfahren implementiert zur sicheren und
            datenschutzkonformen Löschung von Mandantendaten, sobald diese nicht mehr benötigt
            werden oder gesetzliche Aufbewahrungsfristen abgelaufen sind; Rechtsgrundlagen:
            Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO),
            Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO), Berechtigte Interessen
            (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
          <li>
            Kontaktverwaltung und Kontaktpflege: Verfahren, die im Rahmen der Organisation, Pflege
            und Sicherung von Kontaktinformationen erforderlich sind (z. B. die Einrichtung und
            Wartung einer zentralen Kontaktdatenbank, regelmäßige Aktualisierungen der
            Kontaktinformationen, Überwachung der Datenintegrität, Implementierung von
            Datenschutzmaßnahmen, Sicherstellung der Zugriffskontrollen, Durchführung von Backups
            und Wiederherstellungen der Kontaktdaten, Schulung von Mitarbeitern im effektiven Umgang
            mit Kontaktmanagement-Software, regelmäßige Überprüfung der Kommunikationshistorie und
            Anpassung der Kontaktstrategien); Rechtsgrundlagen: Vertragserfüllung und
            vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO), Berechtigte Interessen
            (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">
          Bereitstellung des Onlineangebots und Webhosting
        </h2>
        <p className="mb-4">
          Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur Verfügung stellen
          zu können. Zu diesem Zweck verarbeiten wir die IP-Adresse des Nutzers, die notwendig ist,
          um die Inhalte und Funktionen unserer Online-Dienste an den Browser oder das Endgerät der
          Nutzer zu übermitteln.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
            Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen); Meta-, Kommunikations- und
            Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte
            Personen); Protokolldaten (z. B. Logfiles betreffend Logins oder den Abruf von Daten
            oder Zugriffszeiten.). Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und
            Beiträge sowie die sie betreffenden Informationen, wie z. B. Angaben zur Autorenschaft
            oder Zeitpunkt der Erstellung).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Bereitstellung unseres
            Onlineangebotes und Nutzerfreundlichkeit; Informationstechnische Infrastruktur (Betrieb
            und Bereitstellung von Informationssystemen und technischen Geräten (Computer, Server
            etc.)). Sicherheitsmaßnahmen.
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung".
          </li>
          <li>Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).</li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Bereitstellung Onlineangebot auf gemietetem Speicherplatz: Für die Bereitstellung
            unseres Onlineangebotes nutzen wir Speicherplatz, Rechenkapazität und Software, die wir
            von einem entsprechenden Serveranbieter (auch "Webhoster" genannt) mieten oder
            anderweitig beziehen; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit.
            f) DSGVO).
          </li>
          <li>
            Erhebung von Zugriffsdaten und Logfiles: Der Zugriff auf unser Onlineangebot wird in
            Form von sogenannten "Server-Logfiles" protokolliert. Zu den Serverlogfiles können die
            Adresse und der Name der abgerufenen Webseiten und Dateien, Datum und Uhrzeit des
            Abrufs, übertragene Datenmengen, Meldung über erfolgreichen Abruf, Browsertyp nebst
            Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite) und im
            Regelfall IP-Adressen und der anfragende Provider gehören. Die Serverlogfiles können zum
            einen zu Sicherheitszwecken eingesetzt werden, z. B. um eine Überlastung der Server zu
            vermeiden (insbesondere im Fall von missbräuchlichen Angriffen, sogenannten
            DDoS-Attacken), und zum anderen, um die Auslastung der Server und ihre Stabilität
            sicherzustellen; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
            DSGVO). Löschung von Daten: Logfile-Informationen werden für die Dauer von maximal 30
            Tagen gespeichert und danach gelöscht oder anonymisiert. Daten, deren weitere
            Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen Klärung des
            jeweiligen Vorfalls von der Löschung ausgenommen.
          </li>
          <li>
            E-Mail-Versand und -Hosting: Die von uns in Anspruch genommenen Webhosting-Leistungen
            umfassen ebenfalls den Versand, den Empfang sowie die Speicherung von E-Mails. Zu diesen
            Zwecken werden die Adressen der Empfänger sowie Absender als auch weitere Informationen
            betreffend den E-Mailversand (z. B. die beteiligten Provider) sowie die Inhalte der
            jeweiligen E-Mails verarbeitet. Die vorgenannten Daten können ferner zu Zwecken der
            Erkennung von SPAM verarbeitet werden. Wir bitten darum, zu beachten, dass E-Mails im
            Internet grundsätzlich nicht verschlüsselt versendet werden. Im Regelfall werden E-Mails
            zwar auf dem Transportweg verschlüsselt, aber (sofern kein sogenanntes
            Ende-zu-Ende-Verschlüsselungsverfahren eingesetzt wird) nicht auf den Servern, von denen
            sie abgesendet und empfangen werden. Wir können daher für den Übertragungsweg der
            E-Mails zwischen dem Absender und dem Empfang auf unserem Server keine Verantwortung
            übernehmen; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Einsatz von Cookies</h2>
        <p className="mb-4">
          Unter dem Begriff „Cookies" werden Funktionen, die Informationen auf Endgeräten der Nutzer
          speichern und aus ihnen auslesen, verstanden. Cookies können ferner in Bezug auf
          unterschiedliche Anliegen Einsatz finden, etwa zu Zwecken der Funktionsfähigkeit, der
          Sicherheit und des Komforts von Onlineangeboten sowie der Erstellung von Analysen der
          Besucherströme. Wir verwenden Cookies gemäß den gesetzlichen Vorschriften. Dazu holen wir,
          wenn erforderlich, vorab die Zustimmung der Nutzer ein. Ist eine Zustimmung nicht
          notwendig, setzen wir auf unsere berechtigten Interessen. Dies gilt, wenn das Speichern
          und Auslesen von Informationen unerlässlich ist, um ausdrücklich angeforderte Inhalte und
          Funktionen bereitstellen zu können. Dazu zählen etwa die Speicherung von Einstellungen
          sowie die Sicherstellung der Funktionalität und Sicherheit unseres Onlineangebots. Die
          Einwilligung kann jederzeit widerrufen werden. Wir informieren klar über deren Umfang und
          welche Cookies genutzt werden.
        </p>
        <p className="mb-4">
          Hinweise zu datenschutzrechtlichen Rechtsgrundlagen: Ob wir personenbezogene Daten
          mithilfe von Cookies verarbeiten, hängt von einer Einwilligung ab. Liegt eine Einwilligung
          vor, dient sie als Rechtsgrundlage. Ohne Einwilligung stützen wir uns auf unsere
          berechtigten Interessen, die vorstehend in diesem Abschnitt und im Kontext der jeweiligen
          Dienste und Verfahren erläutert sind.
        </p>
        <p className="mb-4">
          Speicherdauer: Im Hinblick auf die Speicherdauer werden die folgenden Arten von Cookies
          unterschieden:
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Temporäre Cookies (auch: Session- oder Sitzungscookies): Temporäre Cookies werden
            spätestens gelöscht, nachdem ein Nutzer ein Onlineangebot verlassen und sein Endgerät
            (z. B. Browser oder mobile Applikation) geschlossen hat.
          </li>
          <li>
            Permanente Cookies: Permanente Cookies bleiben auch nach dem Schließen des Endgeräts
            gespeichert. So können beispielsweise der Log-in-Status gespeichert und bevorzugte
            Inhalte direkt angezeigt werden, wenn der Nutzer eine Website erneut besucht. Ebenso
            können die mithilfe von Cookies erhobenen Nutzerdaten zur Reichweitenmessung Verwendung
            finden. Sofern wir Nutzern keine expliziten Angaben zur Art und Speicherdauer von
            Cookies mitteilen (z. B. im Rahmen der Einholung der Einwilligung), sollten sie davon
            ausgehen, dass diese permanent sind und die Speicherdauer bis zu zwei Jahre betragen
            kann.
          </li>
        </ul>
        <p className="mb-4">
          Allgemeine Hinweise zum Widerruf und Widerspruch (Opt-out): Nutzer können die von ihnen
          abgegebenen Einwilligungen jederzeit widerrufen und zudem einen Widerspruch gegen die
          Verarbeitung entsprechend den gesetzlichen Vorgaben, auch mittels der
          Privatsphäre-Einstellungen ihres Browsers, erklären.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Meta-, Kommunikations- und Verfahrensdaten (z. B. IP-Adressen,
            Zeitangaben, Identifikationsnummern, beteiligte Personen).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
            Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitung von Cookie-Daten auf Grundlage einer Einwilligung: Wir setzen eine
            Einwilligungs-Management-Lösung ein, bei der die Einwilligung der Nutzer zur Verwendung
            von Cookies oder zu den im Rahmen der Einwilligungs-Management-Lösung genannten
            Verfahren und Anbietern eingeholt wird. Dieses Verfahren dient der Einholung,
            Protokollierung, Verwaltung und dem Widerruf von Einwilligungen, insbesondere bezogen
            auf den Einsatz von Cookies und vergleichbaren Technologien, die zur Speicherung, zum
            Auslesen und zur Verarbeitung von Informationen auf den Endgeräten der Nutzer eingesetzt
            werden. Im Rahmen dieses Verfahrens werden die Einwilligungen der Nutzer für die Nutzung
            von Cookies und die damit verbundenen Verarbeitungen von Informationen, einschließlich
            der im Einwilligungs-Management-Verfahren genannten spezifischen Verarbeitungen und
            Anbieter, eingeholt. Die Nutzer haben zudem die Möglichkeit, ihre Einwilligungen zu
            verwalten und zu widerrufen. Die Einwilligungserklärungen werden gespeichert, um eine
            erneute Abfrage zu vermeiden und den Nachweis der Einwilligung gemäß der gesetzlichen
            Anforderungen führen zu können. Die Speicherung erfolgt serverseitig und/oder in einem
            Cookie (sogenanntes Opt-In-Cookie) oder mittels vergleichbarer Technologien, um die
            Einwilligung einem spezifischen Nutzer oder dessen Gerät zuordnen zu können. Sofern
            keine spezifischen Angaben zu den Anbietern von Einwilligungs-Management-Diensten
            vorliegen, gelten folgende allgemeine Hinweise: Die Dauer der Speicherung der
            Einwilligung beträgt bis zu zwei Jahre. Dabei wird ein pseudonymer Nutzer-Identifikator
            erstellt, der zusammen mit dem Zeitpunkt der Einwilligung, den Angaben zum Umfang der
            Einwilligung (z. B. betreffende Kategorien von Cookies und/oder Diensteanbieter) sowie
            Informationen über den Browser, das System und das verwendete Endgerät gespeichert wird;
            Rechtsgrundlagen: Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">
          Verarbeitung von Daten im Rahmen von Applikationen (Apps)
        </h2>
        <p className="mb-4">
          Wir verarbeiten die Daten der Nutzer unserer Applikation, soweit diese erforderlich sind,
          um den Nutzern die Applikation sowie deren Funktionalitäten bereitstellen, deren
          Sicherheit überwachen und sie weiterentwickeln zu können. Wir können ferner Nutzer unter
          Beachtung der gesetzlichen Vorgaben kontaktieren, sofern die Kommunikation zu Zwecken der
          Administration oder Nutzung der Applikation erforderlich ist. Im Übrigen verweisen wir im
          Hinblick auf die Verarbeitung der Daten der Nutzer auf die Datenschutzhinweise in dieser
          Datenschutzerklärung.
        </p>
        <p className="mb-4">
          Rechtsgrundlagen: Die Verarbeitung von Daten, die für die Bereitstellung der
          Funktionalitäten der Applikation erforderlich ist, dient der Erfüllung von vertraglichen
          Pflichten. Dies gilt auch, wenn die Bereitstellung der Funktionen eine Berechtigung der
          Nutzer (z. B. Freigaben von Gerätefunktionen) voraussetzt. Sofern die Verarbeitung von
          Daten für die Bereitstellung der Funktionalitäten der Applikation nicht erforderlich ist,
          aber der Sicherheit der Applikation oder unseren betriebswirtschaftlichen Interessen dient
          (z. B. Erhebung von Daten zu Zwecken der Optimierung der Applikation oder
          Sicherheitszwecken), erfolgt sie auf Grundlage unserer berechtigten Interessen. Sofern
          Nutzer ausdrücklich deren Einwilligung in die Verarbeitung ihrer Daten gebeten werden,
          erfolgt die Verarbeitung der von der Einwilligung umfassten Daten auf Grundlage der
          Einwilligung.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
            Kontaktinformationen, Kundennummer, etc.); Nutzungsdaten (z. B. Seitenaufrufe und
            Verweildauer, Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Meta-, Kommunikations- und
            Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte
            Personen).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Erbringung vertraglicher Leistungen
            und Erfüllung vertraglicher Pflichten; Sicherheitsmaßnahmen. Bereitstellung unseres
            Onlineangebotes und Nutzerfreundlichkeit.
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung".
          </li>
          <li>
            Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO). Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Geräteberechtigungen für den Zugriff auf Funktionen und Daten: Die Nutzung unserer
            Applikation oder ihrer Funktionalitäten kann Berechtigungen der Nutzer für Zugriff auf
            bestimmten Funktionen der verwendeten Geräte oder auf die, auf den Geräten gespeicherten
            oder mit Hilfe der Geräte zugänglichen Daten voraussetzen. Standardmäßig müssen diese
            Berechtigungen von den Nutzern erteilt werden und können jederzeit in den Einstellungen
            der jeweiligen Geräte widerrufen werden. Das genaue Verfahren zur Kontrolle der
            App-Berechtigungen kann vom Gerät und der Software der Nutzern abhängig sein. Bei
            Erläuterungsbedarf können sich Nutzer an uns wenden. Wir weisen darauf hin, dass die
            Versagung oder Widerruf der jeweiligen Berechtigungen die Funktionsfähigkeit unsere
            Applikation beeinflussen kann.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Registrierung, Anmeldung und Nutzerkonto</h2>
        <p className="mb-4">
          Nutzer können ein Nutzerkonto anlegen. Im Rahmen der Registrierung werden den Nutzern die
          erforderlichen Pflichtangaben mitgeteilt und zu Zwecken der Bereitstellung des
          Nutzerkontos auf Grundlage vertraglicher Pflichterfüllung verarbeitet. Zu den
          verarbeiteten Daten gehören insbesondere die Login-Informationen (Nutzername, Passwort
          sowie eine E-Mail-Adresse).
        </p>
        <p className="mb-4">
          Im Rahmen der Inanspruchnahme unserer Registrierungs- und Anmeldefunktionen sowie der
          Nutzung des Nutzerkontos speichern wir die IP-Adresse und den Zeitpunkt der jeweiligen
          Nutzerhandlung. Die Speicherung erfolgt auf Grundlage unserer berechtigten Interessen als
          auch jener der Nutzer an einem Schutz vor Missbrauch und sonstiger unbefugter Nutzung.
          Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, es sei denn, sie ist
          zur Verfolgung unserer Ansprüche erforderlich oder es besteht eine gesetzliche
          Verpflichtung hierzu.
        </p>
        <p className="mb-4">
          Die Nutzer können über Vorgänge, die für deren Nutzerkonto relevant sind, wie z. B.
          technische Änderungen, per E-Mail informiert werden.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
            Kontaktinformationen, Kundennummer, etc.); Kontaktdaten (z. B. Post- und E-Mail-Adressen
            oder Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und
            Beiträge sowie die sie betreffenden Informationen, wie z. B. Angaben zur Autorenschaft
            oder Zeitpunkt der Erstellung); Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
            Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Protokolldaten (z. B.
            Logfiles betreffend Logins oder den Abruf von Daten oder Zugriffszeiten.).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Erbringung vertraglicher Leistungen
            und Erfüllung vertraglicher Pflichten; Sicherheitsmaßnahmen; Organisations- und
            Verwaltungsverfahren. Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung". Löschung nach Kündigung.
          </li>
          <li>
            Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO). Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Profile der Nutzer sind nicht öffentlich: Die Profile der Nutzer sind öffentlich nicht
            sichtbar und nicht zugänglich.
          </li>
          <li>
            Löschung von Daten nach Kündigung: Wenn Nutzer ihr Nutzerkonto gekündigt haben, werden
            deren Daten im Hinblick auf das Nutzerkonto, vorbehaltlich einer gesetzlichen Erlaubnis,
            Pflicht oder Einwilligung der Nutzer, gelöscht; Rechtsgrundlagen: Vertragserfüllung und
            vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).
          </li>
          <li>
            Keine Aufbewahrungspflicht für Daten: Es obliegt den Nutzern, ihre Daten bei erfolgter
            Kündigung vor dem Vertragsende zu sichern. Wir sind berechtigt, sämtliche während der
            Vertragsdauer gespeicherte Daten des Nutzers unwiederbringlich zu löschen;
            Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Kontakt- und Anfrageverwaltung</h2>
        <p className="mb-4">
          Bei der Kontaktaufnahme mit uns (z. B. per Post, Kontaktformular, E-Mail, Telefon oder via
          soziale Medien) sowie im Rahmen bestehender Nutzer- und Geschäftsbeziehungen werden die
          Angaben der anfragenden Personen verarbeitet, soweit dies zur Beantwortung der
          Kontaktanfragen und etwaiger angefragter Maßnahmen erforderlich ist.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Kontaktdaten (z. B. Post- und E-Mail-Adressen oder
            Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und Beiträge
            sowie die sie betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder
            Zeitpunkt der Erstellung). Meta-, Kommunikations- und Verfahrensdaten (z. B.
            IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte Personen).
          </li>
          <li>Betroffene Personen: Kommunikationspartner.</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Kommunikation; Organisations- und
            Verwaltungsverfahren; Feedback (z. B. Sammeln von Feedback via Online-Formular).
            Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung".
          </li>
          <li>
            Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
            Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Kontaktformular: Bei Kontaktaufnahme über unser Kontaktformular, per E-Mail oder anderen
            Kommunikationswegen, verarbeiten wir die uns übermittelten personenbezogenen Daten zur
            Beantwortung und Bearbeitung des jeweiligen Anliegens. Dies umfasst in der Regel Angaben
            wie Name, Kontaktinformationen und gegebenenfalls weitere Informationen, die uns
            mitgeteilt werden und zur angemessenen Bearbeitung erforderlich sind. Wir nutzen diese
            Daten ausschließlich für den angegebenen Zweck der Kontaktaufnahme und Kommunikation;
            Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Künstliche Intelligenz (KI)</h2>
        <p className="mb-4">
          Wir setzen Künstliche Intelligenz (KI) ein, wobei personenbezogene Daten verarbeitet
          werden. Die spezifischen Zwecke und unser Interesse am Einsatz der KI werden nachfolgend
          genannt. Unter KI verstehen wir entsprechend dem Begriff eines "KI-Systems" gemäß Artikel
          3 Nr. 1 der KI-Verordnung ein maschinengestütztes System, das für einen in wechselndem
          Maße autonomen Betrieb ausgelegt ist, nach seiner Einführung anpassungsfähig sein kann und
          aus den erhaltenen Eingaben Ergebnisse wie Vorhersagen, Inhalte, Empfehlungen oder
          Entscheidungen hervorbringt, die physische oder virtuelle Umgebungen beeinflussen können.
        </p>
        <p className="mb-4">
          Unsere KI-Systeme werden unter strikter Beachtung der gesetzlichen Vorgaben eingesetzt.
          Diese umfassen sowohl spezifische Regelungen für Künstliche Intelligenz als auch
          Datenschutzvorgaben. Dabei halten wir insbesondere die Prinzipien der Rechtmäßigkeit,
          Transparenz, Fairness, menschlichen Kontrolle, Zweckbindung, Datenminimierung und
          Integrität sowie Vertraulichkeit ein. Wir stellen sicher, dass die Verarbeitung
          personenbezogener Daten stets auf einer rechtlichen Grundlage erfolgt. Dies kann entweder
          die Einwilligung der betroffenen Personen oder eine gesetzliche Erlaubnis sein.
        </p>
        <p className="mb-4">
          Bei der Nutzung externer KI-Systeme wählen wir deren Anbieter (nachfolgend "KI-Anbieter")
          sorgfältig aus. Entsprechend unseren gesetzlichen Pflichten stellen wir sicher, dass die
          KI-Anbieter die geltenden Bestimmungen einhalten. Ebenso beachten wir die uns obliegenden
          Pflichten bei Nutzung oder Betrieb der bezogenen KI-Leistungen. Die Verarbeitung
          personenbezogener Daten durch uns und die KI-Anbieter erfolgt ausschließlich auf Grundlage
          einer Einwilligung oder gesetzlichen Berechtigung. Dabei legen wir besonderen Wert auf
          Transparenz, Fairness und die Wahrung der menschlichen Kontrolle über KI-gestützte
          Entscheidungsprozesse.
        </p>
        <p className="mb-4">
          Zum Schutz der verarbeiteten Daten implementieren wir angemessene und robuste technische
          sowie organisatorische Maßnahmen. Diese gewährleisten die Integrität und Vertraulichkeit
          der verarbeiteten Daten und minimieren potenzielle Risiken. Durch regelmäßige
          Überprüfungen der KI-Anbieter und ihrer Leistungen stellen wir die fortlaufende Einhaltung
          aktueller rechtlicher und ethischer Standards sicher.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und
            Beiträge sowie die sie betreffenden Informationen, wie z. B. Angaben zur Autorenschaft
            oder Zeitpunkt der Erstellung). Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
            Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen).
          </li>
          <li>
            Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten). Dritte
            Personen.
          </li>
          <li>Zwecke der Verarbeitung und berechtigte Interessen: Künstliche Intelligenz (KI).</li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung".
          </li>
          <li>Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).</li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Microsoft Copilot: Microsoft Copilot: Unterstützung bei der Erstellung und Bearbeitung
            von Texten, Tabellen und Präsentationen, Analyse von Daten, Automatisierung von Aufgaben
            und Integration in Office-Anwendungen. Verarbeitet werden Inhaltsdaten (Dateien,
            Gespräche, Metadaten) sowie Beschäftigten-Berechtigungsnachweise (Org-ID/Entra ID) zu
            Zwecken der Effizienz- und Produktivitätssteigerungen, Kosteneffizienz, Flexibilität,
            Mobilität und Integration mit M365. Chatverläufe werden bis zu 30 Tage gespeichert,
            Inhalte bis zur Löschung durch den Nutzer. Zusätzlich werden Diagnosedaten zur
            Produktstabilität und Verbesserung erhoben; Dienstanbieter: Microsoft Ireland Operations
            Limited, One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, D18
            P521, Irland; Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA;
            Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO); Website:{' '}
            <a
              href="https://www.microsoft.com/de-de/microsoft-copilot/organizations"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://www.microsoft.com/de-de/microsoft-copilot/organizations
            </a>
            ; Datenschutzerklärung:{' '}
            <a
              href="https://www.microsoft.com/de-de/privacy/privacystatement"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://www.microsoft.com/de-de/privacy/privacystatement
            </a>
            ; Auftragsverarbeitungsvertrag:{' '}
            <a
              href="https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA
            </a>
            . Grundlage Drittlandtransfers: Data Privacy Framework (DPF), Standardvertragsklauseln (
            <a
              href="https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA
            </a>
            ).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">
          Newsletter und elektronische Benachrichtigungen
        </h2>
        <p className="mb-4">
          Wir versenden Newsletter, E-Mails und weitere elektronische Benachrichtigungen
          (nachfolgend „Newsletter") ausschließlich mit der Einwilligung der Empfänger oder aufgrund
          einer gesetzlichen Grundlage. Sofern im Rahmen einer Anmeldung zum Newsletter dessen
          Inhalte genannt werden, sind diese Inhalte für die Einwilligung der Nutzer maßgeblich. Für
          die Anmeldung zu unserem Newsletter ist normalerweise die Angabe Ihrer E-Mail-Adresse
          ausreichend. Um Ihnen jedoch einen personalisierten Service bieten zu können, bitten wir
          gegebenenfalls um die Angabe Ihres Namens für eine persönliche Ansprache im Newsletter
          oder um weitere Informationen, falls diese für den Zweck des Newsletters notwendig sind.
        </p>
        <p className="mb-4">
          Löschung und Einschränkung der Verarbeitung: Wir können die ausgetragenen E-Mail-Adressen
          bis zu drei Jahren auf Grundlage unserer berechtigten Interessen speichern, bevor wir sie
          löschen, um eine ehemals gegebene Einwilligung nachweisen zu können. Die Verarbeitung
          dieser Daten wird auf den Zweck einer potenziellen Abwehr von Ansprüchen beschränkt. Ein
          individueller Löschungsantrag ist jederzeit möglich, sofern zugleich das ehemalige
          Bestehen einer Einwilligung bestätigt wird. Im Fall von Pflichten zur dauerhaften
          Beachtung von Widersprüchen behalten wir uns die Speicherung der E-Mail-Adresse alleine zu
          diesem Zweck in einer Sperrliste (sogenannte „Blocklist") vor.
        </p>
        <p className="mb-4">
          Die Protokollierung des Anmeldeverfahrens erfolgt auf Grundlage unserer berechtigten
          Interessen zum Zweck des Nachweises seines ordnungsgemäßen Ablaufs. Soweit wir einen
          Dienstleister mit dem Versand von E-Mails beauftragen, erfolgt dies auf Grundlage unserer
          berechtigten Interessen an einem effizienten und sicheren Versandsystem.
        </p>
        <p className="mb-4">Inhalte: </p>
        <p className="mb-4">Informationen zu uns, unseren Leistungen, Aktionen und Angeboten.</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
            Kontaktinformationen, Kundennummer, etc.); Kontaktdaten (z. B. Post- und E-Mail-Adressen
            oder Telefonnummern). Meta-, Kommunikations- und Verfahrensdaten (z. B. IP-Adressen,
            Zeitangaben, Identifikationsnummern, beteiligte Personen).
          </li>
          <li>Betroffene Personen: Kommunikationspartner.</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Direktmarketing (z. B. per E-Mail
            oder postalisch).
          </li>
          <li>Rechtsgrundlagen: Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO).</li>
          <li>
            Widerspruchsmöglichkeit (Opt-Out): Sie können den Empfang unseres Newsletters jederzeit
            kündigen, d. .h. Ihre Einwilligungen widerrufen, bzw. dem weiteren Empfang
            widersprechen. Einen Link zur Kündigung des Newsletters finden Sie entweder am Ende
            eines jeden Newsletters oder können sonst eine der oben angegebenen
            Kontaktmöglichkeiten, vorzugswürdig E-Mail, hierzu nutzen.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Webanalyse, Monitoring und Optimierung</h2>
        <p className="mb-4">
          Die Webanalyse (auch als „Reichweitenmessung" bezeichnet) dient der Auswertung der
          Besucherströme unseres Onlineangebots und kann Verhalten, Interessen oder demografische
          Informationen zu den Besuchern, wie beispielsweise Alter oder Geschlecht, als pseudonyme
          Werte umfassen. Mithilfe der Reichweitenanalyse können wir zum Beispiel erkennen, zu
          welcher Zeit unser Onlineangebot oder dessen Funktionen beziehungsweise Inhalte am
          häufigsten genutzt werden, oder zur Wiederverwendung einladen. Ebenso ist es uns möglich,
          nachzuvollziehen, welche Bereiche der Optimierung bedürfen.{' '}
        </p>
        <p className="mb-4">
          Neben der Webanalyse können wir auch Testverfahren einsetzen, um etwa unterschiedliche
          Versionen unseres Onlineangebots oder seiner Bestandteile zu testen und zu optimieren.
        </p>
        <p className="mb-4">
          Sofern nachfolgend nicht anders angegeben, können zu diesen Zwecken Profile, also zu einem
          Nutzungsvorgang zusammengefasste Daten, angelegt und Informationen in einem Browser bzw.
          in einem Endgerät gespeichert und dann ausgelesen werden. Zu den erhobenen Angaben gehören
          insbesondere besuchte Websites und dort genutzte Elemente sowie technische Auskünfte, wie
          etwa der verwendete Browser, das benutzte Computersystem sowie Angaben zu Nutzungszeiten.
          Sofern sich Nutzer in die Erhebung ihrer Standortdaten uns gegenüber oder gegenüber den
          Anbietern der von uns eingesetzten Dienste einverstanden erklärt haben, ist auch die
          Verarbeitung von Standortdaten möglich.
        </p>
        <p className="mb-4">
          Darüber hinaus werden die IP-Adressen der Nutzer gespeichert. Jedoch nutzen wir ein
          IP-Masking-Verfahren (d. h. Pseudonymisierung durch Kürzung der IP-Adresse) zum Schutz der
          Nutzer. Generell werden die im Rahmen von Webanalyse, A/B-Testings und Optimierung keine
          Klardaten der Nutzer (wie z. B. E-Mail-Adressen oder Namen) gespeichert, sondern
          Pseudonyme. Das heißt, wir als auch die Anbieter der eingesetzten Software kennen nicht
          die tatsächliche Identität der Nutzer, sondern nur die zum Zweck der jeweiligen Verfahren
          in deren Profilen gespeicherten Angaben.
        </p>
        <p className="mb-4">
          Hinweise zu Rechtsgrundlagen: Sofern wir die Nutzer um deren Einwilligung in den Einsatz
          der Drittanbieter bitten, stellt die Rechtsgrundlage der Datenverarbeitung die
          Einwilligung dar. Ansonsten werden die Nutzerdaten auf Grundlage unserer berechtigten
          Interessen (d. h. Interesse an effizienten, wirtschaftlichen und empfängerfreundlichen
          Leistungen) verarbeitet. In diesem Zusammenhang möchten wir Sie auch auf die Informationen
          zur Verwendung von Cookies in dieser Datenschutzerklärung hinweisen.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
            Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Meta-, Kommunikations- und
            Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte
            Personen).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Reichweitenmessung (z. B.
            Zugriffsstatistiken, Erkennung wiederkehrender Besucher). Profile mit nutzerbezogenen
            Informationen (Erstellen von Nutzerprofilen).
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung". Speicherung von Cookies von bis zu 2
            Jahren (Sofern nicht anders angegeben, können Cookies und ähnliche Speichermethoden für
            einen Zeitraum von zwei Jahren auf den Geräten der Nutzer gespeichert werden.).
          </li>
          <li>Sicherheitsmaßnahmen: IP-Masking (Pseudonymisierung der IP-Adresse).</li>
          <li>
            Rechtsgrundlagen: Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO). Berechtigte
            Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">
          Plug-ins und eingebettete Funktionen sowie Inhalte
        </h2>
        <p className="mb-4">
          Wir binden Funktions- und Inhaltselemente in unser Onlineangebot ein, die von den Servern
          ihrer jeweiligen Anbieter (nachfolgend als „Drittanbieter" bezeichnet) bezogen werden.
          Dabei kann es sich zum Beispiel um Grafiken, Videos oder Stadtpläne handeln (nachfolgend
          einheitlich als „Inhalte" bezeichnet).
        </p>
        <p className="mb-4">
          Die Einbindung setzt immer voraus, dass die Drittanbieter dieser Inhalte die IP-Adresse
          der Nutzer verarbeiten, da sie ohne IP-Adresse die Inhalte nicht an deren Browser senden
          könnten. Die IP-Adresse ist damit für die Darstellung dieser Inhalte oder Funktionen
          erforderlich. Wir bemühen uns, nur solche Inhalte zu verwenden, deren jeweilige Anbieter
          die IP-Adresse lediglich zur Auslieferung der Inhalte anzuwenden. Drittanbieter können
          ferner sogenannte Pixel-Tags (unsichtbare Grafiken, auch als „Web Beacons" bezeichnet) für
          statistische oder Marketingzwecke einsetzen. Durch die „Pixel-Tags" können Informationen,
          wie etwa der Besucherverkehr auf den Seiten dieser Website, ausgewertet werden. Die
          pseudonymen Informationen können darüber hinaus in Cookies auf dem Gerät der Nutzer
          gespeichert werden und unter anderem technische Auskünfte zum Browser und zum
          Betriebssystem, zu verweisenden Websites, zur Besuchszeit sowie weitere Angaben zur
          Nutzung unseres Onlineangebots enthalten, aber auch mit solchen Informationen aus anderen
          Quellen verbunden werden.
        </p>
        <p className="mb-4">
          Hinweise zu Rechtsgrundlagen: Sofern wir die Nutzer um ihre Einwilligung in den Einsatz
          der Drittanbieter bitten, stellt die Rechtsgrundlage der Datenverarbeitung die Erlaubnis
          dar. Ansonsten werden die Nutzerdaten auf Grundlage unserer berechtigten Interessen (d. h.
          Interesse an effizienten, wirtschaftlichen und empfängerfreundlichen Leistungen)
          verarbeitet. In diesem Zusammenhang möchten wir Sie auch auf die Informationen zur
          Verwendung von Cookies in dieser Datenschutzerklärung hinweisen.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Verarbeitete Datenarten: Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
            Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen und
            Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Meta-, Kommunikations- und
            Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte
            Personen).
          </li>
          <li>Betroffene Personen: Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
          <li>
            Zwecke der Verarbeitung und berechtigte Interessen: Bereitstellung unseres
            Onlineangebotes und Nutzerfreundlichkeit; Reichweitenmessung (z. B. Zugriffsstatistiken,
            Erkennung wiederkehrender Besucher); Tracking (z. B. interessens-/verhaltensbezogenes
            Profiling, Nutzung von Cookies); Zielgruppenbildung. Marketing.
          </li>
          <li>
            Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
            Informationen zur Datenspeicherung und Löschung". Speicherung von Cookies von bis zu 2
            Jahren (Sofern nicht anders angegeben, können Cookies und ähnliche Speichermethoden für
            einen Zeitraum von zwei Jahren auf den Geräten der Nutzer gespeichert werden.).
          </li>
          <li>
            Rechtsgrundlagen: Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO). Berechtigte
            Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
        <p className="mb-4">Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            YouTube-Videos: Videoinhalte; Dienstanbieter: Google Ireland Limited, Gordon House,
            Barrow Street, Dublin 4, Irland; Rechtsgrundlagen: Einwilligung (Art. 6 Abs. 1 S. 1 lit.
            a) DSGVO); Website:{' '}
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://www.youtube.com
            </a>
            ; Datenschutzerklärung:{' '}
            <a
              href="https://business.safety.google/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://business.safety.google/privacy/
            </a>
            ; Grundlage Drittlandtransfers: Data Privacy Framework (DPF). Widerspruchsmöglichkeit
            (Opt-Out): Opt-Out-Plugin:{' '}
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>
            , Einstellungen für die Darstellung von Werbeeinblendungen:{' '}
            <a
              href="https://myadcenter.google.com/personalizationoff"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              https://myadcenter.google.com/personalizationoff
            </a>
            .
          </li>
          <li>
            Audit-Trail: Zur Gewährleistung der Sicherheit und Nachvollziehbarkeit von
            Datenverarbeitungen werden Änderungen an Daten protokolliert. Dabei werden insbesondere
            Zeitpunkt, Art der Änderung und die zugehörige Benutzerkennung erfasst. Die
            Protokolldaten werden ausschließlich auf Systemen in Deutschland gespeichert und nicht
            an Dritte übermittelt. Sensible Inhalte werden in den Protokollen geschwärzt.
          </li>
          <li>
            KI-Protokollierung (Langfuse): Zur Überwachung, Fehleranalyse und Qualitätssicherung
            unserer KI-Anwendungen werden Eingaben, generierte Ausgaben sowie technische
            Nutzungsdaten protokolliert. Hierfür nutzen wir eine selbst gehostete Instanz von
            Langfuse auf Servern in Deutschland. Eine Verarbeitung durch den Anbieter von Langfuse
            oder eine Übermittlung an sonstige Dritte erfolgt nicht.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Änderung und Aktualisierung</h2>
        <p className="mb-4">
          Wir bitten Sie, sich regelmäßig über den Inhalt unserer Datenschutzerklärung zu
          informieren. Wir passen die Datenschutzerklärung an, sobald die Änderungen der von uns
          durchgeführten Datenverarbeitungen dies erforderlich machen. Wir informieren Sie, sobald
          durch die Änderungen eine Mitwirkungshandlung Ihrerseits (z. B. Einwilligung) oder eine
          sonstige individuelle Benachrichtigung erforderlich wird.
        </p>
        <p className="mb-4">
          Sofern wir in dieser Datenschutzerklärung Adressen und Kontaktinformationen von
          Unternehmen und Organisationen angeben, bitten wir zu beachten, dass die Adressen sich
          über die Zeit ändern können und bitten die Angaben vor Kontaktaufnahme zu prüfen.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-3">Begriffsdefinitionen</h2>
        <p className="mb-4">
          In diesem Abschnitt erhalten Sie eine Übersicht über die in dieser Datenschutzerklärung
          verwendeten Begrifflichkeiten. Soweit die Begrifflichkeiten gesetzlich definiert sind,
          gelten deren gesetzliche Definitionen. Die nachfolgenden Erläuterungen sollen dagegen vor
          allem dem Verständnis dienen.
        </p>
        <ul className="list-disc ml-5 mb-4 space-y-1">
          <li>
            Bestandsdaten: Bestandsdaten umfassen wesentliche Informationen, die für die
            Identifikation und Verwaltung von Vertragspartnern, Benutzerkonten, Profilen und
            ähnlichen Zuordnungen notwendig sind. Diese Daten können u.a. persönliche und
            demografische Angaben wie Namen, Kontaktinformationen (Adressen, Telefonnummern,
            E-Mail-Adressen), Geburtsdaten und spezifische Identifikatoren (Benutzer-IDs)
            beinhalten. Bestandsdaten bilden die Grundlage für jegliche formelle Interaktion
            zwischen Personen und Diensten, Einrichtungen oder Systemen, indem sie eine eindeutige
            Zuordnung und Kommunikation ermöglichen.{' '}
          </li>
          <li>
            Inhaltsdaten: Inhaltsdaten umfassen Informationen, die im Zuge der Erstellung,
            Bearbeitung und Veröffentlichung von Inhalten aller Art generiert werden. Diese
            Kategorie von Daten kann Texte, Bilder, Videos, Audiodateien und andere multimediale
            Inhalte einschließen, die auf verschiedenen Plattformen und Medien veröffentlicht
            werden. Inhaltsdaten sind nicht nur auf den eigentlichen Inhalt beschränkt, sondern
            beinhalten auch Metadaten, die Informationen über den Inhalt selbst liefern, wie Tags,
            Beschreibungen, Autoreninformationen und Veröffentlichungsdaten{' '}
          </li>
          <li>
            Kontaktdaten: Kontaktdaten sind essentielle Informationen, die die Kommunikation mit
            Personen oder Organisationen ermöglichen. Sie umfassen u.a. Telefonnummern, postalische
            Adressen und E-Mail-Adressen, sowie Kommunikationsmittel wie soziale Medien-Handles und
            Instant-Messaging-Identifikatoren.{' '}
          </li>
          <li>
            Künstliche Intelligenz (KI): Der Zweck der Verarbeitung von Daten durch Künstliche
            Intelligenz (KI) umfasst die automatisierte Analyse und Verarbeitung von Nutzerdaten, um
            Muster zu erkennen, Vorhersagen zu treffen und die Effizienz sowie die Qualität unserer
            Dienstleistungen zu verbessern. Dies beinhaltet die Sammlung, Bereinigung und
            Strukturierung der Daten, das Training und die Anwendung von KI-Modellen sowie die
            kontinuierliche Überprüfung und Optimierung der Ergebnisse und erfolgt ausschließlich
            mit Einwilligung der Nutzer oder aufgrund gesetzlicher Erlaubnisgrundlagen.{' '}
          </li>
          <li>
            Meta-, Kommunikations- und Verfahrensdaten: Meta-, Kommunikations- und Verfahrensdaten
            sind Kategorien, die Informationen über die Art und Weise enthalten, wie Daten
            verarbeitet, übermittelt und verwaltet werden. Meta-Daten, auch bekannt als Daten über
            Daten, umfassen Informationen, die den Kontext, die Herkunft und die Struktur anderer
            Daten beschreiben. Sie können Angaben zur Dateigröße, dem Erstellungsdatum, dem Autor
            eines Dokuments und den Änderungshistorien beinhalten. Kommunikationsdaten erfassen den
            Austausch von Informationen zwischen Nutzern über verschiedene Kanäle, wie
            E-Mail-Verkehr, Anrufprotokolle, Nachrichten in sozialen Netzwerken und Chat-Verläufe,
            inklusive der beteiligten Personen, Zeitstempel und Übertragungswege. Verfahrensdaten
            beschreiben die Prozesse und Abläufe innerhalb von Systemen oder Organisationen,
            einschließlich Workflow-Dokumentationen, Protokolle von Transaktionen und Aktivitäten,
            sowie Audit-Logs, die zur Nachverfolgung und Überprüfung von Vorgängen verwendet
            werden.{' '}
          </li>
          <li>
            Nutzungsdaten: Nutzungsdaten beziehen sich auf Informationen, die erfassen, wie Nutzer
            mit digitalen Produkten, Dienstleistungen oder Plattformen interagieren. Diese Daten
            umfassen eine breite Palette von Informationen, die aufzeigen, wie Nutzer Anwendungen
            nutzen, welche Funktionen sie bevorzugen, wie lange sie auf bestimmten Seiten verweilen
            und über welche Pfade sie durch eine Anwendung navigieren. Nutzungsdaten können auch die
            Häufigkeit der Nutzung, Zeitstempel von Aktivitäten, IP-Adressen, Geräteinformationen
            und Standortdaten einschließen. Sie sind besonders wertvoll für die Analyse des
            Nutzerverhaltens, die Optimierung von Benutzererfahrungen, das Personalisieren von
            Inhalten und das Verbessern von Produkten oder Dienstleistungen. Darüber hinaus spielen
            Nutzungsdaten eine entscheidende Rolle beim Erkennen von Trends, Vorlieben und möglichen
            Problembereichen innerhalb digitaler Angebote{' '}
          </li>
          <li>
            Personenbezogene Daten: "Personenbezogene Daten" sind alle Informationen, die sich auf
            eine identifizierte oder identifizierbare natürliche Person (im Folgenden "betroffene
            Person") beziehen; als identifizierbar wird eine natürliche Person angesehen, die direkt
            oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer
            Kennnummer, zu Standortdaten, zu einer Online-Kennung (z. B. Cookie) oder zu einem oder
            mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen,
            physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen
            Identität dieser natürlichen Person sind.{' '}
          </li>
          <li>
            Profile mit nutzerbezogenen Informationen: Die Verarbeitung von "Profilen mit
            nutzerbezogenen Informationen", bzw. kurz "Profilen" umfasst jede Art der
            automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese
            personenbezogenen Daten verwendet werden, um bestimmte persönliche Aspekte, die sich auf
            eine natürliche Person beziehen (je nach Art der Profilbildung können dazu
            unterschiedliche Informationen betreffend die Demographie, Verhalten und Interessen, wie
            z. B. die Interaktion mit Webseiten und deren Inhalten, etc.) zu analysieren, zu
            bewerten oder, um sie vorherzusagen (z. B. die Interessen an bestimmten Inhalten oder
            Produkten, das Klickverhalten auf einer Webseite oder den Aufenthaltsort). Zu Zwecken
            des Profilings werden häufig Cookies und Web-Beacons eingesetzt.{' '}
          </li>
          <li>
            Protokolldaten: Protokolldaten sind Informationen über Ereignisse oder Aktivitäten, die
            in einem System oder Netzwerk protokolliert wurden. Diese Daten enthalten typischerweise
            Informationen wie Zeitstempel, IP-Adressen, Benutzeraktionen, Fehlermeldungen und andere
            Details über die Nutzung oder den Betrieb eines Systems. Protokolldaten werden oft zur
            Analyse von Systemproblemen, zur Sicherheitsüberwachung oder zur Erstellung von
            Leistungsberichten verwendet.{' '}
          </li>
          <li>
            Reichweitenmessung: Die Reichweitenmessung (auch als Web Analytics bezeichnet) dient der
            Auswertung der Besucherströme eines Onlineangebotes und kann das Verhalten oder
            Interessen der Besucher an bestimmten Informationen, wie z. B. Inhalten von Webseiten,
            umfassen. Mit Hilfe der Reichweitenanalyse können Betreiber von Onlineangeboten z. B.
            erkennen, zu welcher Zeit Nutzer ihre Webseiten besuchen und für welche Inhalte sie sich
            interessieren. Dadurch können sie z. B. die Inhalte der Webseiten besser an die
            Bedürfnisse ihrer Besucher anpassen. Zu Zwecken der Reichweitenanalyse werden häufig
            pseudonyme Cookies und Web-Beacons eingesetzt, um wiederkehrende Besucher zu erkennen
            und so genauere Analysen zur Nutzung eines Onlineangebotes zu erhalten.{' '}
          </li>
          <li>
            Standortdaten: Standortdaten entstehen, wenn sich ein mobiles Gerät (oder ein anderes
            Gerät mit den technischen Voraussetzungen einer Standortbestimmung) mit einer Funkzelle,
            einem WLAN oder ähnlichen technischen Mitteln und Funktionen der Standortbestimmung,
            verbindet. Standortdaten dienen der Angabe, an welcher geografisch bestimmbaren Position
            der Erde sich das jeweilige Gerät befindet. Standortdaten können z. B. eingesetzt
            werden, um Kartenfunktionen oder andere von einem Ort abhängige Informationen
            darzustellen.{' '}
          </li>
          <li>
            Tracking: Vom "Tracking" spricht man, wenn das Verhalten von Nutzern über mehrere
            Onlineangebote hinweg nachvollzogen werden kann. Im Regelfall werden im Hinblick auf die
            genutzten Onlineangebote Verhaltens- und Interessensinformationen in Cookies oder auf
            Servern der Anbieter der Trackingtechnologien gespeichert (sogenanntes Profiling). Diese
            Informationen können anschließend z. B. eingesetzt werden, um den Nutzern Werbeanzeigen
            anzuzeigen, die voraussichtlich deren Interessen entsprechen.{' '}
          </li>
          <li>
            Verantwortlicher: Als "Verantwortlicher" wird die natürliche oder juristische Person,
            Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen über die
            Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet,
            bezeichnet.{' '}
          </li>
          <li>
            Verarbeitung: "Verarbeitung" ist jeder mit oder ohne Hilfe automatisierter Verfahren
            ausgeführte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen
            Daten. Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das
            Erheben, das Auswerten, das Speichern, das Übermitteln oder das Löschen.{' '}
          </li>
          <li>
            Vertragsdaten: Vertragsdaten sind spezifische Informationen, die sich auf die
            Formalisierung einer Vereinbarung zwischen zwei oder mehr Parteien beziehen. Sie
            dokumentieren die Bedingungen, unter denen Dienstleistungen oder Produkte
            bereitgestellt, getauscht oder verkauft werden. Diese Datenkategorie ist wesentlich für
            die Verwaltung und Erfüllung vertraglicher Verpflichtungen und umfasst sowohl die
            Identifikation der Vertragsparteien als auch die spezifischen Bedingungen und
            Konditionen der Vereinbarung. Vertragsdaten können Start- und Enddaten des Vertrages,
            die Art der vereinbarten Leistungen oder Produkte, Preisvereinbarungen,
            Zahlungsbedingungen, Kündigungsrechte, Verlängerungsoptionen und spezielle Bedingungen
            oder Klauseln umfassen. Sie dienen als rechtliche Grundlage für die Beziehung zwischen
            den Parteien und sind entscheidend für die Klärung von Rechten und Pflichten, die
            Durchsetzung von Ansprüchen und die Lösung von Streitigkeiten.{' '}
          </li>
          <li>
            Zahlungsdaten: Zahlungsdaten umfassen sämtliche Informationen, die zur Abwicklung von
            Zahlungstransaktionen zwischen Käufern und Verkäufern benötigt werden. Diese Daten sind
            von entscheidender Bedeutung für den elektronischen Handel, das Online-Banking und jede
            andere Form der finanziellen Transaktion. Sie beinhalten Details wie
            Kreditkartennummern, Bankverbindungen, Zahlungsbeträge, Transaktionsdaten,
            Verifizierungsnummern und Rechnungsinformationen. Zahlungsdaten können auch
            Informationen über den Zahlungsstatus, Rückbuchungen, Autorisierungen und Gebühren
            enthalten.{' '}
          </li>
          <li>
            Zielgruppenbildung: Von Zielgruppenbildung (englisch "Custom Audiences") spricht man,
            wenn Zielgruppen für Werbezwecke, z. B. Einblendung von Werbeanzeigen bestimmt werden.
            So kann z. B. anhand des Interesses eines Nutzers an bestimmten Produkten oder Themen im
            Internet geschlussfolgert werden, dass dieser Nutzer sich für Werbeanzeigen für ähnliche
            Produkte oder den Onlineshop, in dem er die Produkte betrachtet hat, interessiert. Von
            "Lookalike Audiences" (bzw. ähnlichen Zielgruppen) spricht man wiederum, wenn die als
            geeignet eingeschätzten Inhalte Nutzern angezeigt werden, deren Profile, bzw. Interessen
            mutmaßlich den Nutzern zu denen die Profile gebildet wurden, entsprechen. Zur Zwecken
            der Bildung von Custom Audiences und Lookalike Audiences werden im Regelfall Cookies und
            Web-Beacons eingesetzt.{' '}
          </li>
        </ul>
      </section>
    </div>
  );
}
